import { useCallback } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { getNextQueryParams } from "components/helpers";
import withRoleCheck from "components/hocs/withRoleCheck";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import _ScheduleModal from "routes/campaign/components/ScheduleModal";
import CampaignScheduleService from "services/CampaignScheduleService";
import { useEmailScheduleTable } from "hooks/useEmailScheduleTable";

export const EMAIL_SCHEDULE_TABLE_CONSTANTS = {
  tableName: "email_schedules",
  exportTableName: "CampaignSchedulesTable",
  className: null,
  header: null,
  headerIcon: null,
};

const ScheduleModal = withRoleCheck(_ScheduleModal, [
  ACL_RELATIONSHIPS.campaignSchedule.create,
]);

const EmailScheduleTableV3 = ({ campaignId = null }) => {
  const { columns, queryKey, invalidateData } = useEmailScheduleTable({
    campaignId,
  });

  const fetchEmailSchedules = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response = await CampaignScheduleService.getSchedules(
          campaignId,
          nextQueryParams
        );

        return response;
      } catch (error) {
        console.error("Error fetching email schedules:", error);
        throw error;
      }
    },
    [columns, campaignId]
  );

  return (
    <BaseTableV3
      columns={columns}
      queryKey={queryKey}
      exportTableName={EMAIL_SCHEDULE_TABLE_CONSTANTS.exportTableName}
      tableName={EMAIL_SCHEDULE_TABLE_CONSTANTS.tableName}
      downloadParams={{
        campaign_id: campaignId,
      }}
      enableSettings
      createButton={
        <ScheduleModal
          isClone={false}
          campaignId={campaignId}
          fetchData={invalidateData}
        />
      }
      fetchData={fetchEmailSchedules}
      invalidateData={invalidateData}
    />
  );
};

export default EmailScheduleTableV3;
